module.exports = __webpack_public_path__ + "static/media/view5.6f5bcb77.jpg";